import React from "react";
import Marquee from "react-fast-marquee";
import { PARTNERS } from "../lib/siteData";

export default function PartnerMarquee() {
  return (
    <section className="py-12 bg-slate-50 border-y border-slate-200" data-testid="partners-section">
      <div className="container-narrow mb-6 text-center">
        <div className="text-xs font-bold uppercase tracking-widest text-blue-700 mb-2">Trusted Partners</div>
        <h3 className="text-xl sm:text-2xl font-heading font-semibold text-slate-900">We work with India's top solar brands</h3>
      </div>
      <Marquee gradient={true} gradientColor="rgb(248, 250, 252)" speed={40}>
        {PARTNERS.map((p, i) => (
          <div key={i} className="mx-8 flex items-center gap-2 text-slate-500 hover:text-slate-900 transition">
            <p.icon className="w-6 h-6" />
            <span className="font-heading font-semibold text-lg tracking-tight whitespace-nowrap">{p.name}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
